import React from 'react';

import Container from './Container';
import VerticalLine from './VerticalLine';

import OrderReceived from './OrderReceived';
import ShipmentState from './ShipmentState';
import DeliveryState from './DeliveryState';

export default ({ shipment, ...rest }) => {
  const { status, received_at, delivered_at, shipped_at, shipper, tracking_number, tracking_url, gokada_label_url } = shipment || {};
  console.log(shipment)
  return (
    <div {...rest}>
      <Container>
        <VerticalLine />
        <OrderReceived shipment={shipment} />
        <ShipmentState
          status={status}
          shipped_at={shipped_at}
          shipper={shipper}
          tracking_number={tracking_number}
          tracking_url={tracking_url}
          gokada_label_url={gokada_label_url}
        />
      </Container>
      <DeliveryState status={status} delivered_at={delivered_at} />
    </div>
  );
};
